import { EntDirectoryInfoName } from "../../../models/directoryInfoName";
import { EntInitialFilterName } from "../../../models/filters/initialFilterName";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { agroApi } from "../api";
import { Paths } from "../../../paths";

export const realEstateLangCategoriesApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getRealEstateLangCategoriesList: builder.query<ResponseDataGet<EntDirectoryInfoName>, EntInitialFilterName>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.realestatelangcategories }/get-all`,
		method: "POST",
		body: JSON.stringify(filter),
	  }),
	}),

	getRealEstateLangCategoriesById: builder.query<ResponseDataGet<EntDirectoryInfoName>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.realestatelangcategories }/${ id }`,
		method: 'GET',
	  }),
	}),

	addRealEstateLangCategories: builder.mutation<ResponseDataGet<EntDirectoryInfoName>, EntDirectoryInfoName>({
	  query: (body) => ({
		url: `${ Paths.handbooks.realestatelangcategories }`,
		method: "POST",
		body: JSON.stringify(body),
	  }),
	}),

	editRealEstateLangCategories: builder.mutation<ResponseDataGet<EntDirectoryInfoName>, EntDirectoryInfoName>({
	  query: (body) => ({
		url: `${ Paths.handbooks.realestatelangcategories }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),

	deleteRealEstateLangCategories: builder.mutation<ResponseDataGet<EntDirectoryInfoName>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.realestatelangcategories }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useAddRealEstateLangCategoriesMutation,
  useDeleteRealEstateLangCategoriesMutation,
  useEditRealEstateLangCategoriesMutation,
  useLazyGetRealEstateLangCategoriesListQuery
} = realEstateLangCategoriesApi;
